// Region preference manager. Stored in localStorage, used to filter
// product suggestions by country of sale on Open Food Facts.
const REGION_KEY = 'allergen_app_country';

export const SUPPORTED_REGIONS = [
  { code: '',   name: 'Todas',    flag: '🌍', offTag: '' },
  { code: 'es', name: 'España',   flag: '🇪🇸', offTag: 'en:spain' },
  { code: 'fr', name: 'Francia',  flag: '🇫🇷', offTag: 'en:france' },
  { code: 'pt', name: 'Portugal', flag: '🇵🇹', offTag: 'en:portugal' },
  { code: 'de', name: 'Alemania', flag: '🇩🇪', offTag: 'en:germany' },
  { code: 'it', name: 'Italia',   flag: '🇮🇹', offTag: 'en:italy' },
  { code: 'uk', name: 'Reino Unido', flag: '🇬🇧', offTag: 'en:united-kingdom' },
];

export const getRegion = () => localStorage.getItem(REGION_KEY) || '';

export const setRegion = (code) => {
  if (code) {
    localStorage.setItem(REGION_KEY, code);
  } else {
    localStorage.removeItem(REGION_KEY);
  }
};
